import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PageState {
  [tableName: string]: number;
}

const initialState: PageState = {
  defaultTable: 0,
};

const tablePageSlice = createSlice({
  name: "pageNumber",
  initialState,
  reducers: {
    setTablePage: (
      state,
      action: PayloadAction<{ tableName: string; pageNumber: number }>
    ) => {
      state[action.payload.tableName] = action.payload.pageNumber;
      localStorage.setItem(
        `${action.payload.tableName}Page`,
        JSON.stringify(action.payload.pageNumber)
      );
    },
    removeTablePage: (state, action: PayloadAction<string>) => {
      delete state[action.payload];
      localStorage.removeItem(action.payload + "Page");
    },
  },
});

export const { setTablePage, removeTablePage } = tablePageSlice.actions;
export default tablePageSlice.reducer;
